
import { ActivityLogEntity } from "domain/entity/ActivityLog/ActivityLogEntity";
import { EMPTY_MONTH_END_CLOSURE_ENTITY, MonthEndClosureEntity } from "domain/entity/MonthEndClosure/MonthEndClosureEntity";
import { EMPTY_RESERVATION_ITEM_ENTITY, ReservationItemEntity } from "domain/entity/MonthEndClosure/ReservationItemEntity";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";

export interface MonthEndClosureDropdownOptions {
    tariffTypeDropdownOptions: DropdownProps[],
    tariffCodeDropdownOptions: { [key: string]: DropdownProps[] },
    companyCodeDropdownOptions: DropdownProps[],
}
export interface MonthEndClosureState extends BaseViewChangeSate {
}

export interface MonthEndClosureModel {
    isLoading: boolean,
    isShowDtlPanel: boolean,
    isShowActivityLogPanel: boolean,
    isAddReservation: boolean,
    isEditReservation: boolean,
    isMonthEndHdrUpdate: boolean,
    currentSelectedRow: MonthEndClosureEntity,
    currentEditRow: MonthEndClosureEntity,
    currentReservationSelectedRow: ReservationItemEntity,
    currentReservationEditRow: ReservationItemEntity,
    selectedRows: MonthEndClosureEntity[],
    selectedReservationRows: ReservationItemEntity[],
    monthEndClosureList: MonthEndClosureEntity[],
    reservationItemList: ReservationItemEntity[],
    activityLogList: ActivityLogEntity[],
    dynamicOptions: MonthEndClosureDropdownOptions,
}

export const EMPTY_MONTH_END_CLOSURE_MODEL: MonthEndClosureModel = {
    isLoading: false,
    currentSelectedRow: { ...EMPTY_MONTH_END_CLOSURE_ENTITY },
    currentEditRow: { ...EMPTY_MONTH_END_CLOSURE_ENTITY },
    selectedRows: [],
    dynamicOptions: {
        tariffTypeDropdownOptions: [],
        tariffCodeDropdownOptions: {},
        companyCodeDropdownOptions: []
    },
    monthEndClosureList: [],
    isShowDtlPanel: false,
    reservationItemList: [],
    currentReservationSelectedRow: { ...EMPTY_RESERVATION_ITEM_ENTITY },
    currentReservationEditRow: { ...EMPTY_RESERVATION_ITEM_ENTITY },
    selectedReservationRows: [],
    isAddReservation: false,
    isEditReservation: false,
    isMonthEndHdrUpdate: false,
    isShowActivityLogPanel: false,
    activityLogList: []
}